import { ChevronLeft, Instagram, Mail, ChevronRight } from 'lucide-react'

export default function SupportPage() {
  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/feed'
    }
  }

  return (
    <div className="h-screen-mobile-minus-nav bg-background">
      <div className="phone-container-padded">
        {/* Header */}
        <div className="mt-6 flex items-center gap-4 mb-8">
          <button
            onClick={handleBack}
            className="p-2 -ml-2 hover:bg-muted rounded-lg transition-colors"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <h1 className="text-2xl font-bold">Support</h1>
        </div>

        {/* Content */}
        <div className="space-y-8">
          {/* Introduction */}
          <div>
            <p className="text-foreground leading-relaxed text-base">
              Have questions or need support? We'd love to hear from you. Reach out to us through any of the channels below.
            </p>
          </div>

          {/* Support Options */}
          <div className="space-y-6">
            {/* Instagram */}
            <a 
              href="https://instagram.com/getmoretats" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-between gap-4 hover:opacity-70 transition-opacity"
            >
              <div className="flex items-center gap-4">
                <Instagram className="h-6 w-6 text-foreground flex-shrink-0" />
                <div>
                  <p className="font-semibold text-foreground">@getmoretats</p>
                  <p className="text-sm text-muted-foreground">Send us a DM</p>
                </div>
              </div>
              <ChevronRight className="h-6 w-6 text-muted-foreground flex-shrink-0" />
            </a>

            {/* Email */}
            <a 
              href="mailto:info@getmoretats.com"
              className="flex items-center justify-between gap-4 hover:opacity-70 transition-opacity"
            >
              <div className="flex items-center gap-4">
                <Mail className="h-6 w-6 text-foreground flex-shrink-0" />
                <div>
                  <p className="font-semibold text-foreground">info@getmoretats.com</p>
                  <p className="text-sm text-muted-foreground">Email us directly</p>
                </div>
              </div>
              <ChevronRight className="h-6 w-6 text-muted-foreground flex-shrink-0" />
            </a>
          </div>

          {/* Closing */}
          <div className="mt-8 pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              We typically respond to messages within 24-48 hours. Thank you for supporting getmoretats!
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
